import React from 'react'
import { useSelector } from 'react-redux'

import { Icon, TableV2 } from 'src/components'

import { actions } from 'src/actions/cardProvider.actions'
import { selectCardPaymentDevices } from 'src/selectors/cardProvider.selector'

import { loadingSelector } from 'src/selectors/loading.selector'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'
import { isAllowed } from 'src/selectors/modules.selector'
import { cardProviderPermissions } from 'src/enums/permissions'

interface CardProviderDeviceListProps {
  onUpdate: (item: ICardProviderDeviceDetail) => void
  onDelete: (item: ICardProviderDeviceDetail) => void
}

export const CardProviderDeviceList = ({
  onUpdate,
  onDelete,
}: CardProviderDeviceListProps) => {
  const items = useSelector(selectCardPaymentDevices)

  const loading = useSelector(state =>
    loadingSelector([actions.CRUD_CARD_PAYMENT_DEVICE, actions.GET_CARD_PAYMENT_DEVICES])(
      state,
    ),
  )

  const canUpdate = useSelector(state =>
    isAllowed(state, [cardProviderPermissions.updateDevices]),
  )

  const canDelete = useSelector(state =>
    isAllowed(state, [cardProviderPermissions.deleteDevices]),
  )

  const headers: ITableHeader[] = [
    {
      show: true,
      label: 'Código',
      value: ['device', 'code'],
      type: 'text',
    },
    {
      show: true,
      label: 'Nombre',
      value: ['device', 'name'],
      type: 'text',
    },
    {
      show: true,
      label: 'Punto de venta',
      value: ['pos', 'name'],
      type: 'text',
    },
    {
      show: canDelete || canUpdate,
      label: 'Acciones',
      value: [],
      type: 'custom',
      custom: item => (
        <div className={'d-flex'}>
          {canDelete && (
            <Icon
              disabled={loading}
              icon={faTrash}
              color={'secondary'}
              tooltip={'Eliminar'}
              onClick={() => onDelete(item)}
            />
          )}
          {canUpdate && (
            <Icon
              disabled={loading}
              className={'ml-3'}
              icon={faEdit}
              color={'accent'}
              tooltip={'Editar'}
              onClick={() => onUpdate(item)}
            />
          )}
        </div>
      ),
    },
  ]

  return (
    <TableV2
      // @ts-ignore
      loading={loading}
      items={items}
      headers={headers}
    />
  )
}
